import { Link } from "react-router-dom";
import { Instagram, Twitter, Facebook } from "lucide-react";
import { LOGO_URL } from "@/components/Navbar";

const Footer = () => {
  return (
    <footer className="bg-[#1C1C1C] text-[#FDFBF7] mt-0" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div>
          <div className="mb-4">
            <img src={LOGO_URL} alt="Tornado Alley Trading Co." className="h-20 w-auto object-contain" style={{ filter: "brightness(0) invert(1)" }} />
          </div>
          <p className="text-sm text-[#C9C4BA] leading-relaxed">
            Vintage-inspired apparel celebrating Kansas City icons, Midwest grit, and local culture. Wear KC history.
          </p>
          <div className="flex gap-4 mt-5">
            <Instagram className="w-5 h-5 hover:text-[#D35400] cursor-pointer" />
            <Twitter className="w-5 h-5 hover:text-[#D35400] cursor-pointer" />
            <Facebook className="w-5 h-5 hover:text-[#D35400] cursor-pointer" />
          </div>
        </div>
        <div>
          <h4 className="font-display text-2xl mb-4 text-[#D35400]">Shop</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/shop" className="hover:text-[#D35400]">All Products</Link></li>
            <li><Link to="/tee-club" className="hover:text-[#D35400]">Monthly Tee Club</Link></li>
            <li><Link to="/drops" className="hover:text-[#D35400]">Past Drops</Link></li>
            <li><Link to="/shop" className="hover:text-[#D35400]">Stickers & Home Goods</Link></li>
            <li><Link to="/contact" className="hover:text-[#D35400]">Custom Designs</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-display text-2xl mb-4 text-[#D35400]">Company</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/about" className="hover:text-[#D35400]">About Us</Link></li>
            <li><Link to="/contact" className="hover:text-[#D35400]">Contact</Link></li>
            <li><Link to="/account" className="hover:text-[#D35400]">My Account</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-display text-2xl mb-4 text-[#D35400]">Iconic KC</h4>
          <p className="text-sm text-[#C9C4BA] leading-relaxed">
            Our flagship collection — a monthly tribute to the restaurants, bars, landmarks, and sounds that make Kansas City legendary.
          </p>
        </div>
      </div>
      <div className="border-t border-[#3a3a3a] py-6 text-center text-xs text-[#8a857c]">
        © {new Date().getFullYear()} Tornado Alley Trading Co. · Iconic KC · Made in the Midwest.
      </div>
    </footer>
  );
};

export default Footer;
